import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useHomeStore = defineStore({
    id: 'home',
    state: () => ({
        selectionList: [{
            id: 'corporate',
            label: "home.corporate",
            description: 'home.corporateDesc',
        },
        {
            id: 'insurer',
            label: 'home.insurer',
            description: 'home.insurerDesc',
        },
        {
            id: 'patients',
            label: 'home.patients',
            description: 'home.patientsDesc',
        }],
        selectionListTemp: [{
            id: 'corporate',
            label: "Corporate",
            description: "We help you be a Caring Employer.",
        },
        {
            id: 'insurer',
            label: 'Insurer',
            description: "Your valued partner in health for your clients, agents and staff.",
        },
        {
            id: 'patients',
            label: 'Patients',
            description: "Your trusted healthcare provider, optimizing your health and wellbeing."
        }],
        selected: {},
        ourCoreValuescategoryList: [
            {
                id: 'ethics',
                label: 'Ethics',
                image: 'ethics'
            },
            {
                id: 'synergy',
                label: 'Synergy',
                image: 'synergy',
            },
            {
                id: 'teamwork',
                label: 'Teamwork',
                image: 'teamwork'
            }
        ],
        ourServicesCategoryList: [
            {
                id: 'wellness',
                label: 'Wellness',
                image: '#heart',
                description: 'The state of complete physical, mental and </br> social well-being and not merely the </br> absence of disease or infirmity.'
            },
            {
                id: 'treatment',
                label: 'Treatment',
                image: '#stethoscope',
                description: 'Medical intervention for the management <br>of sub-health and disease.',
            },
            {
                id: 'prevention',
                label: 'Prevention',
                image: '#needle',
                description: 'Eradicating, eliminating or minimizing the <br>impact of disease and disability. '
            },
        ],
        //decide whether description show when hover
        ourServicesCategoryListOnHover: [],
        ourServicesCentreList: [
            {
                id: 'checkupcentre',
                label: 'Check Up Centre',
                image: 'checkUpCentre.svg'
            },
            {
                id: '24hourcallcentre',
                label: '24 Hour Call Centre',
                image: 'callCentre.svg'
            },
            {
                id: 'daysurgery',
                label: 'Day Surgery',
                image: 'daySurgery.svg'
            },
        ],
        selectedOurServicesCentre: {},
        faqList: [
            {
                id: 'corporatepackages',
                label: 'sitemap.corporatePack',
                image: 'target',
            },
            {
                id: 'services',
                label: 'sitemap.services',
                image: 'medikit',
            },
            {
                id: 'patients',
                label: 'sitemap.patients',
                image: 'patients',
            },
            {
                id: 'insurancepartners',
                label: 'sitemap.insurancePartners',
                image: 'hands',
            },
            {
                id: 'doctors',
                label: 'sitemap.doctors',
                image: 'share',
            },
            {
                id: 'covid19',
                label: 'sitemap.covid19',
                image: 'virus',
            },
        ],
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useHomeStore, import.meta.hot));
}

export { useHomeStore };
